import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {TextBuiltInControl} from '../TextBuiltInControl';

/**
 * @description base class including font family modifications logic
 */
export abstract class TextFontFamilyBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_TEXT].FONT_FAMILY;
  }
}
